import { render } from "./GenproxDivider.vue?vue&type=template&id=45ccda74&ts=true"
import script from "./GenproxDivider.vue?vue&type=script&lang=ts"
export * from "./GenproxDivider.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./GenproxDivider.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__